import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling, {
  type MutationError
} from '@/hooks/useMutationWithErrorsHandling'

import {
  type CourseFormPayload,
  fieldErrorsMapper
} from '../constants/course-payload'

const useAddCourse = (options?: {
  onSuccess?: ({
    response,
    variables
  }: {
    response: { id: string }
    variables: CourseFormPayload
  }) => void
  onError?: (
    errros: MutationError<CourseFormPayload, unknown>,
    validData: CourseFormPayload
  ) => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: async (data: CourseFormPayload) =>
      httpService.panel.panelCoursesCreate({
        name: data.name,
        education_level: data.educationLevel,
        domain: data.domain.value,
        preferred_rooms: data.preferredRooms?.map(room => room.value)
      }),
    onSuccess: (response, variables) =>
      options?.onSuccess?.({ response, variables }),
    onError: (errors, variables) => {
      options?.onError?.(errors, variables)
    },
    fieldErrorsMapper
  })

export default useAddCourse
